export type CountFrequency = 'Monthly' | 'Quarterly' | 'Annually';
export type TableType = 'VARIABLE' | 'FIXED';
export type RowType = 'primary' | 'secondary' | 'tertiary' | 'member';
export type BuildScenarioRowResult =
  | 'Fees'
  | 'Credits'
  | 'Rebates'
  | 'Member'
  | '';

/**
 * *Modal Types and Empty States
 */

//Vendor Modal
export interface VendorModalType {
  open: boolean;
  type: 'FEES' | 'CREDITS' | 'MEMBER' | 'STOPLOSS';
  actionType: 'ADD' | 'EDIT';
}
export const getEmptyVendorModalState = (): VendorModalType => ({
  open: false,
  type: 'FEES',
  actionType: 'ADD',
});

//Claims Modal
export interface ClaimsModalType {
  open: boolean;
  type: 'FEES' | 'MEMBER';
  actionType: 'ADD' | 'EDIT';
}
export const getEmptyClaimsModalState = (): ClaimsModalType => ({
  open: false,
  type: 'FEES',
  actionType: 'ADD',
});

//Fee Calcualtion Modal
export interface FeeCalculationModalType {
  open: boolean;
  unitOfFees: string;
  actionType: 'ADD' | 'EDIT';
  selectedVendorID: string;
  selectedServiceID: string;
  type: 'FEES' | 'CREDITS' | 'MEMBER';
}
export const getEmptyFeeCalculationModalState = (): FeeCalculationModalType => ({
  open: false,
  unitOfFees: '',
  actionType: 'ADD',
  selectedVendorID: '',
  selectedServiceID: '',
  type: 'FEES',
});

//Reimbursement Modal
export interface ReimbursementModalType {
  open: boolean;
  type: 'REBATES';
  actionType: 'ADD' | 'EDIT';
  selectedVendorID?: string;
}
export const getEmptyReimbursementModalState = (): ReimbursementModalType => ({
  open: false,
  type: 'REBATES',
  actionType: 'ADD',
});

//Other Claims Modal
export interface OtherClaimsModalType {
  open: boolean;
  type: 'FEES' | 'MEMBER';
  actionType: 'ADD' | 'EDIT';
  selectedVendorID?: string;
}
export const getEmptyOtherClaimsModalState = (): OtherClaimsModalType => ({
  open: false,
  type: 'FEES',
  actionType: 'ADD',
  selectedVendorID: '',
});
